<script setup>
import { PaginationListItem } from "reka-ui";
import { cn } from "@/shared/lib/utils";
import { buttonVariants } from "@/shared/ui/button";

const props = defineProps({
  value: { type: Number, required: true },
  isActive: { type: Boolean, default: false },
  size: { type: String, default: "icon-sm" },
  class: { type: [String, Object, Array], default: undefined },
});
</script>

<template>
  <PaginationListItem
    data-slot="pagination-item"
    :value="value"
    :class="
      cn(
        buttonVariants({
          variant: isActive ? 'outline' : 'ghost',
          size: props.size,
        }),
        props.class
      )
    "
  >
    <slot>{{ value }}</slot>
  </PaginationListItem>
</template>
